module.exports = __webpack_public_path__ + "media/images/icon_star-9b73ede2dd31ad7ebe38235816af03bc.svg";